import Typography from "@mui/material/Typography";
import { FC, PropsWithChildren } from "react";

const OauthHeader: FC<PropsWithChildren> = ({ children }) => (
  <Typography component="h1" variant="h5">
    {children}
  </Typography>
);

export default OauthHeader;
